"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BrandCard = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledBrandCard = require("./styled-brand-card");
var _excluded = ["link", "ariaLabel", "backgroundImage", "className", "clickCallback", "dataAnalyticsId", "dataTestId", "label", "logoImage"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef,
  useCallback = _react["default"].useCallback;
var propTypes = {
  link: _propTypes["default"].string.isRequired,
  ariaLabel: _propTypes["default"].string,
  backgroundImage: _propTypes["default"].shape({
    alt: _propTypes["default"].string,
    dataTestId: _propTypes["default"].string,
    isLazy: _propTypes["default"].bool,
    imageSrc: _propTypes["default"].string,
    fallbackSource: _propTypes["default"].string
  }),
  className: _propTypes["default"].string,
  clickCallback: _propTypes["default"].func,
  dataAnalyticsId: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  label: _propTypes["default"].string,
  logoImage: _propTypes["default"].shape({
    alt: _propTypes["default"].string,
    dataTestId: _propTypes["default"].string,
    isLazy: _propTypes["default"].bool,
    imageSrc: _propTypes["default"].string,
    fallbackSource: _propTypes["default"].string
  })
};
var defaultProps = {
  ariaLabel: undefined,
  backgroundImage: {},
  className: 'fuse-brand-card',
  clickCallback: undefined,
  dataAnalyticsId: undefined,
  dataTestId: 'fuse-brand-card-test-id',
  label: '',
  logoImage: {}
};
var BrandCard = exports.BrandCard = forwardRef(function (_ref, ref) {
  var link = _ref.link,
    ariaLabel = _ref.ariaLabel,
    backgroundImage = _ref.backgroundImage,
    className = _ref.className,
    clickCallback = _ref.clickCallback,
    dataAnalyticsId = _ref.dataAnalyticsId,
    dataTestId = _ref.dataTestId,
    label = _ref.label,
    logoImage = _ref.logoImage,
    others = _objectWithoutProperties(_ref, _excluded);
  var backgroundImageAltText = backgroundImage.alt,
    backgroundImageTestId = backgroundImage.dataTestId,
    backgroundImageIsLazy = backgroundImage.isLazy,
    backgroundImageLink = backgroundImage.imageSrc,
    backgroundImageFallbackSource = backgroundImage.fallbackSource;
  var logoImageAltText = logoImage.alt,
    logoImageTestId = logoImage.dataTestId,
    logoImageIsLazy = logoImage.isLazy,
    logoImageLink = logoImage.imageSrc,
    logoImageFallbackSource = logoImage.fallbackSource;
  var isLogoOnly = (logoImageLink || logoImageFallbackSource) && !(backgroundImageLink || backgroundImageFallbackSource);
  var clickHandler = useCallback(function (e) {
    if (typeof clickCallback === 'function') clickCallback(e, ref);
  }, [clickCallback]);
  return /*#__PURE__*/_react["default"].createElement(_styledBrandCard.StyledBrandCard, _extends({}, others, {
    "aria-label": ariaLabel,
    className: className,
    "data-analyticsid": dataAnalyticsId,
    "data-testid": dataTestId,
    href: link,
    onClick: clickHandler,
    ref: ref
  }), (backgroundImageLink || logoImageLink || backgroundImageFallbackSource || logoImageFallbackSource) && /*#__PURE__*/_react["default"].createElement(_styledBrandCard.StyledImageWrapper, {
    isLogoOnly: isLogoOnly
  }, (backgroundImageLink || backgroundImageFallbackSource) && /*#__PURE__*/_react["default"].createElement(_styledBrandCard.StyledBackgroundImage, _extends({
    alt: backgroundImageAltText,
    dataTestId: backgroundImageTestId,
    fallbackSource: backgroundImageLink,
    isLazy: backgroundImageIsLazy
  }, backgroundImage)), (logoImageLink || logoImageFallbackSource) && /*#__PURE__*/_react["default"].createElement(_styledBrandCard.StyledLogoImage, _extends({
    alt: logoImageAltText,
    dataTestId: logoImageTestId,
    fallbackSource: logoImageLink,
    isLazy: logoImageIsLazy,
    isLogoOnly: isLogoOnly
  }, logoImage))), label && /*#__PURE__*/_react["default"].createElement(_styledBrandCard.StyledLabel, {
    isLogoOnly: isLogoOnly
  }, label));
});
BrandCard.propTypes = propTypes;
BrandCard.defaultProps = defaultProps;
var _default = exports["default"] = BrandCard;